if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.submitButton = this.querySelector('[type="submit"]');
      this.cartNotification = document.getElementById('cart-notification');
      this.cartNotificationItem = document.getElementById('cart-notification-item');
      this.multi_item_request = false;
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.inFlight || this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;

      // Everyday Studio: sticky submit delegates to the canonical product form.
      // Use the actual selected inputs and native validation; app-specific fields still need store testing.
      if (this.closest('product-buy-bar')) {
        const mainId = this.form.getAttribute('id').replace(/-product-buy-bar$/, '');
        const mainForm = document.getElementById(mainId);
        const mainButton = mainForm?.querySelector('button[type="submit"][name="add"]');
        if (mainForm && mainButton) {
          if (!mainButton.disabled) mainForm.requestSubmit(mainButton);
          return;
        }
      }


      this.handleErrorMessage();

      this.inFlight = true;
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay')?.classList.remove('hidden');

      // Upsell items handled only in JS
      const upsell_ids_nodes = document.querySelectorAll(`[data-form="${this.form.getAttribute('id')}"] .upsell-id`);
      const upsell_quantities_nodes = document.querySelectorAll(`[data-form="${this.form.getAttribute('id')}"] .upsell-quantity`);
      let upsell_items = [];

      if (upsell_ids_nodes.length !== 0) {
        const upsell_ids = Array.from(upsell_ids_nodes).map(input => parseInt(input.value));
        const upsell_quantities = Array.from(upsell_quantities_nodes).map(input => parseInt(input.value));
        upsell_items = upsell_ids.map((id, index) => ({'id': id,'quantity': upsell_quantities[index]})).filter(item => Number.isSafeInteger(item.id) && item.id > 0 && Number.isSafeInteger(item.quantity) && item.quantity > 0);
      }

      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
        }
      }
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);

      const hasUpload = Array.from(formData.values()).some(value => value instanceof File && value.size > 0);
      if (upsell_items.length && hasUpload) {
        this.handleErrorMessage(window.esStrings?.fileUpsellError || 'Add this personalized item first, then the optional extras.');
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay')?.classList.add('hidden');
        this.inFlight = false;
        return;
      }
      // If upsell items added refactor FormData
      if (upsell_items.length > 0) {
        this.multi_item_request = true;
        const items = upsell_items;
        const id = parseInt(formData.get('id'));
        const quantity = parseInt(formData.get('quantity')) || 1;
        const the_product_item = { 'id': id, 'quantity': quantity };
        const properties = Object.create(null);
        for (const [name, value] of formData.entries()) {
          const property = name.match(/^properties\[(.+)\]$/);
          if (property && typeof value === 'string') properties[property[1]] = value;
        }
        if (Object.keys(properties).length) the_product_item.properties = properties;
        const sellingPlan = formData.get('selling_plan');
        if (sellingPlan) the_product_item.selling_plan = sellingPlan;

        items.push(the_product_item);
        const itemsData = { 'items': items };

        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify(itemsData);
      } else {
        this.multi_item_request = false;
        config.body = formData;
      }

      try {
        const res = await fetch(routes.cart_add_url + '.js', config)
        const json = await res.json();

        if (!res.ok) throw new Error(typeof json.description === 'string' ? json.description : json.message || window.esStrings?.addError);

        try {

        if (this.cartNotification) {
          const notificationTemplate = document.importNode(this.cartNotification.content, true);

          if (this.multi_item_request) {
            notificationTemplate.querySelector('[data-notification-title]').textContent = window.variantStrings.itemsAdded;
            let lastElement = json.items.pop();
            json.items.unshift(lastElement);

            json.items.forEach(item => {
              const singleItem = this.createNotificationItem(item);
              notificationTemplate.querySelector('[data-items]').appendChild(singleItem);
            });
          } else {
            notificationTemplate.querySelector('[data-notification-title]').textContent = window.variantStrings.itemAdded;
            const singleItem = this.createNotificationItem(json);
            notificationTemplate.querySelector('[data-items]').appendChild(singleItem);
          }

          if (document.querySelector('.cart-notification')) {
            document.querySelector('.cart-notification').remove();
          }

          document.body.appendChild(notificationTemplate);

          const the_notification = document.querySelector('.cart-notification');

          // Set focus to the notification for accessibility
          the_notification.setAttribute('tabindex', '-1');
          the_notification.focus();

          the_notification.querySelector('.notification-close').addEventListener('click', () => {
            the_notification.classList.remove('anim-in');
          });
          setTimeout(() => {
            the_notification.classList.add('anim-in');
          }, 50);
        }

        } catch (notificationError) { console.warn('Cart notification could not render', notificationError); }
        this.resetQuantityInput();
        const event = new CustomEvent('ajaxProduct:added', { detail: { formId: this.form.getAttribute('id') } })
        document.dispatchEvent(event)
      } catch(error) {
        this.handleErrorMessage(error.message || window.esStrings?.addError);
        console.error(error);
      }

      this.submitButton.classList.remove('loading');
      this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay')?.classList.add('hidden');
      this.inFlight = false;
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper') || document.querySelector(`.product-form__error-message-wrapper[form="${this.form.getAttribute('id')}"]`)
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    resetQuantityInput() {
      const hidden_quantity_input = this.form.elements.namedItem('quantity');
      if (hidden_quantity_input && hidden_quantity_input.type === 'hidden') {
        hidden_quantity_input.value = 1;
      }
    }

    createNotificationItem(product) {
      const notificationItemTemplate = document.importNode(this.cartNotificationItem.content, true);

      const image = notificationItemTemplate.querySelector('.notification-item-image');
      if (product.image) {
        const imageURL = new URL(product.image, window.location.origin);
        imageURL.searchParams.set('width', '120');
        image.setAttribute('src', imageURL.href);
        image.setAttribute('alt', product.product_title || '');
        image.classList.remove('hide');
      } else {
        image.hidden = true;
      }
      notificationItemTemplate.querySelector('.notification-item-title').textContent = product.product_title;

      (product.options_with_values || []).forEach(item => {
        const row = document.createElement("dl");
        const nameCell = document.createElement("dt");
        const valueCell = document.createElement("dd");

        nameCell.textContent = item.name + ': ';
        valueCell.textContent = item.value;

        row.appendChild(nameCell);
        row.appendChild(valueCell);
        notificationItemTemplate.querySelector('.notification-item-details').appendChild(row);
      })

      const propertyKeyValues = Object.entries(product.properties || {});
      if (propertyKeyValues.length > 0) {
        const properties = document.createElement("dl");
        propertyKeyValues.forEach(([key, value]) => {
          const startsWith = key.startsWith('_');
          if (startsWith) return;
          const row = document.createElement("dl");
          const nameCell = document.createElement("dt");
          const valueCell = document.createElement("dd");

          nameCell.textContent = key + ': ';
          valueCell.textContent = value;

          row.appendChild(nameCell);
          row.appendChild(valueCell);
          properties.appendChild(row);
        });
        notificationItemTemplate.querySelector('.notification-item-details').appendChild(properties);
      }

      return notificationItemTemplate;
    }
  });
}

class AddMultiplier extends HTMLElement {
  constructor() {
    super();

    const multiplyButton = this.querySelector('button');
    this.submitEvent = new SubmitEvent("submit", { submitter: multiplyButton });
    this.multiplyBy = parseInt(this.querySelector('[name=multiplied-quantity]').value);
    this.productForm = this.closest('product-form').querySelector('form');
    const formId = this.productForm.getAttribute('id');
    this.quantity_input = document.querySelector(`[name=quantity][form=${ formId }]`);
    multiplyButton.addEventListener('click', this.submitProductForm.bind(this));
  }

  submitProductForm() {
    const quantity = this.quantity_input || this.productForm.elements.namedItem('quantity');
    if (!quantity) return;
    quantity.value = this.multiplyBy;
    this.productForm.requestSubmit(this.productForm.querySelector('button[type=submit][name=add]'));
  }
}
customElements.define("add-multiplier", AddMultiplier);
